import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PageContent from '../Content'

export default class Methods extends PageContent {

    // TODO: load baseName from config.json
    async loadItems() {
        const getItems = async () => {
            const response = await fetch(
                process.env.PUBLIC_URL + '/data/methods.json'
            );
            const data = await response.json();
            this.setItems(data);
        };
      
        await getItems();
    }

    runCustomFilter() {
        let filter;

        const compare = this.wholeWords?
            (str, substr) => str.toLocaleLowerCase() === substr:
            (str, substr) => str.toLocaleLowerCase().includes(substr);

        if(this.owner && this.method) {
            filter = item => compare(item.ownerName, this.owner) && (compare(item.oldName, this.method) || compare(item.newName, this.method))
        } else if(this.owner) {
            filter = item => compare(item.ownerName, this.owner);
        } else if(this.method) {
            filter = item => (compare(item.oldName, this.method) || compare(item.newName, this.method))
        } else {
            filter = item => true;
        }
        this.setFilter(filter);
    }

    getNav() {
        return (
            <Container className='mt-4'>
                <Row>
                    <Col>
                        <Form.Control 
                            placeholder='Vlastník'
                            onChange={e => this.owner = e.target.value.toLocaleLowerCase()} 
                            onKeyDown={(e) => { if(e.key === 'Enter') this.runCustomFilter(); }} 
                        />
                    </Col>
                    <Col>
                        <Form.Control 
                            placeholder='Metoda'
                            onChange={e => this.method = e.target.value.toLocaleLowerCase()} 
                            onKeyDown={(e) => { if(e.key === 'Enter') this.runCustomFilter(); }} 
                        />
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col className='text-end'>
                        <Button variant='success' onClick={() => this.runCustomFilter()}>Hledat</Button>
                    </Col>
                    <Col className='align-middle' style={{display: 'flex', alignItems: 'center'}}>
                        <Form.Check label='Celá slova' onClick={e => this.wholeWords = e.target.value}/>
                    </Col>
                </Row>
            </Container>
        );
    }

    getTableHeader() {
        return (
            <tr>
                <th className='col-md-2'/>
                <th className='col-md-2 text-end'>Vlastník</th>
                <th className='col-md-4'>Stará metoda</th>
                <th className='col-md-5'>Nová metoda</th>
            </tr>
        );
    }

    getRow(item, index) {
        let cols = [];
        cols.push(<td key={'type'+index}><span className='text-muted'>{item.type}</span></td>)
        if(item.ownerName)
            cols.push(<td key={'ownerName'+index} className='text-end'><span className='text-muted'>{`${item.ownerName}.`}</span></td>);
        else
            cols.push(<td key={'ownerName'+index}/>);
        cols.push(<td key={'oldName'+index}>{item.oldName}</td>);
        if(item.returnType) {
            cols.push(
                <td key={'newName'+index}>
                    <span>{`${item.newName}` }</span>
                    <span className='text-muted'>{` : ${item.returnType}`}</span>
                </td>
            )
        } else {
            cols.push(
                <td key={'newName'+index}>
                    <span>{item.newName}</span>
                </td>
            )
        }
        return <tr key={index}>{cols}</tr>;
    }
}